"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBoxContainer = exports.FrameContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const polaris_1 = require("@shopify/polaris");
exports.FrameContainer = (0, styled_components_1.default)(polaris_1.Frame) `
  background-color: pink;
`;
exports.CheckBoxContainer = styled_components_1.default.div `
  padding-bottom: 1.25rem;
`;
